export default "__VITE_ASSET__CiQgVZHJ__"